@use '@/sass/variables';

$chip-size: 1.75rem;
$chip-gap: 0.125rem;

.list {
  --group-chip-rows: 1;

  display: grid;
  flex: 1 1 0;
  grid-template-columns: repeat(auto-fill, $chip-size);
  grid-auto-rows: $chip-size;
  gap: $chip-gap;
  min-width: 0;
  max-height: calc(var(--group-chip-rows) * #{$chip-size} + (var(--group-chip-rows) - 1) * #{$chip-gap});
  overflow: hidden;
}

.chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: variables.$border-radius-2;
  width: $chip-size;
  height: $chip-size;
  flex-shrink: 0;
  background-color: variables.$mid-gray;
}

.number {
  font-size: variables.$font-size-7;
  font-weight: 600;
  line-height: 1;
}

.overflow {
  composes: chip;
  background-color: transparent;
  border: 1px solid variables.$mid-gray;

  .number {
    color: variables.$mid-gray;
  }
}

.light {
  color: variables.$white;
}

.dark {
  color: variables.$near-black;
}

:export {
  lightTextColor: variables.$white;
  defaultBackgroundColor: variables.$mid-gray;
}
